import { render, staticRenderFns } from "./process-type.vue?vue&type=template&id=a26fae92&scoped=true&"
import script from "./process-type.vue?vue&type=script&lang=js&"
export * from "./process-type.vue?vue&type=script&lang=js&"
import style0 from "./process-type.vue?vue&type=style&index=0&id=a26fae92&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26fae92",
  null
  
)

export default component.exports